import styles from '../../../../styles/modules/components/SelfServe/enter-address.module.scss';
import Image from '../../../../components/common/Image'
import { useEffect, useState } from 'react';

export const AddressSelector = (props: any) => {

    const [selected, setSelected] = useState<boolean>(props.editAddressId===props.id || false)

    useEffect(()=>{
        setSelected(props.editAddressId===props.id)
    },[props.editAddressId])

const getNonServiceableMessage =() =>{
    let message='';
    if(props.productArray.length === 1 ){
    props.productArray.forEach(product=>message+=product)
    message += ' is not available in '+props.city;
    } else { 
        props.productArray.map((product,index)=>{
            if(props.productArray.length-1 !== index){message+=product + ', '}
            else message+=product
    })
        message += ' are not available in '+props.city;
    }
    
    return message;
}

    return (
            <div className={styles.parent_address_card} style={{"position":"relative"}}>
                <div className={`${styles.address_card} ${selected  && !props.isDisable && styles.selected_box} ${props.isDisable && styles.disable_box}`} 
                onClick={()=>{ props.addressSelectedEvent({address:props.full_address, city:props.city, pincode:props.pincode})
                    if(!props.full_address && !props.isDisable){props.updateEditAddressId(props.id,"edit"); props.updateEditMode(true,"edit")} else if(!props.isDisable) { props.updateEditAddressId(props.id); }}}>
                    <div className={styles.radio_section}>
                        <input type='radio' className={styles.radio_button} onClick={()=>{!props.isDisable && props.updateEditAddressId(props.id);}} checked={selected}/>
                    </div>
                    <div className={styles.address_section} >
                        <div className={styles.address_title}>
                            <p className={styles.address_title_para}>{props.label ? props.label : "Other"}</p>
                            { props.verified && <div className={styles.verified}>
                                <div className={styles.verfied_icon_div}>
                                    <Image src={"/static/images/greeen-tick.png"} width="10px" height="10px" />
                                </div>
                                <p>Verified</p>
                            </div>
                            }
                        </div>
                        <div className={styles.div_full_address}>
                            <p className={styles.full_address}>{props.formatted_address}</p>
                            <p className={styles.full_address}>{props.city},{props.state} - {props.pincode} </p>
                        </div>
                    </div>
                </div>
                <div className={`${styles.address_actions} ${props.verified && !props.isDisable && styles.justify_end} ${props.isDisable && styles.disable_box}`}>
                        { (props.isDisable || !props.verified) && <div className={styles.verification}>
                        {(!props.isDisable || props.isMobile) &&<>
                                <div className={props.isDisable &&styles.icon}>
                                    <Image src={"/static/images/warning_icon_36.png"} width="12px" height="12px" />
                                </div>
                                 <p className={styles.verify_text}>{(props.isDisable && props.isMobile)?getNonServiceableMessage():'Verification pending'}</p>
                                 </>
                                 }
                                {!props.isDisable && <p onClick={()=>{ props.updateEditAddressId(props.id,"verify"); props.updateEditMode(true,"verify",props); props.updateVerify(true)}} className={styles.verify}>Verify Now</p>}
                            </div>
                        }
                           <p onClick={()=>{if(!props.isDisable){props.updateEditAddressId(props.id,"edit"); props.updateEditMode(true,"edit",props)}}} className={styles.edit}>
                                Edit
                            </p>

                        </div>
                        
                        { props.isDisable && !props.isMobile &&   
                        <>
                            <div className={styles.notServicableMessage}>
                                <div className={styles.icon}>
                                    <Image src={"/static/images/warning_icon_36.png"} width="12px" height="12px" />
                                </div>
                                <div className={styles.message}>
                                    <p className={styles.verify_text}>{getNonServiceableMessage()}</p>
                                </div>
                                <div  className={styles.on_hover} style={{backgroundColor:'white'}}>
                                {getNonServiceableMessage()}
                                </div>
                            </div>
                            
                        </>
                        }
                </div>
                
                
    )
}